var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pesquisa", {
        attrs: {
          cardStyle: _vm.cardStyle,
          placeHolder: "Informe o nome ou CPF do beneficiário",
          isSearchOnChange: true
        },
        on: { search: _vm.search }
      }),
      _c(
        "el-card",
        {
          staticClass: "card",
          style: _vm.cardStyle,
          attrs: { shadow: "hover" }
        },
        [
          _c("div", { staticClass: "card-header-financeiro" }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c("div", [
                  _c(
                    "h3",
                    {
                      class: _vm.isBeneficiariosDiferentes ? "text" : "titulo"
                    },
                    [_vm._v("Beneficiários")]
                  )
                ]),
                _vm._t("button-adicionar")
              ],
              2
            )
          ]),
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.paginatedData[_vm.pagina] },
              on: {
                "expand-change": _vm.collapseOnChange,
                "row-click": _vm.toogle
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c("span", [_vm._v(_vm._s(props.row.showGeo))]),
                        _c("app-visualizar-beneficiario", {
                          attrs: {
                            beneficiario: props.row,
                            cadastroOriginal: _vm.cadastroOriginal,
                            isBeneficiariosDiferentes:
                              _vm.isBeneficiariosDiferentes
                          }
                        }),
                        props.row.pessoa.pessoaFisica.dependentes &&
                        props.row.pessoa.pessoaFisica.dependentes.length
                          ? _c("app-divider", {
                              attrs: { label: "Dependentes" }
                            })
                          : _vm._e(),
                        props.row.pessoa.pessoaFisica.dependentes &&
                        props.row.pessoa.pessoaFisica.dependentes.length
                          ? _c("app-dependentes", {
                              attrs: {
                                dependentes:
                                  props.row.pessoa.pessoaFisica.dependentes,
                                protocolo: _vm.cadastroOriginal.protocolo
                              }
                            })
                          : _vm._e(),
                        props.row.documentos && props.row.documentos.length > 0
                          ? _c("listagem-documentos", {
                              attrs: {
                                documentos: props.row.documentos,
                                protocoloCadastroOriginal:
                                  _vm.cadastroOriginal.protocolo,
                                idBeneficiario: props.row._id || props.row.id,
                                isBeneficiario: true,
                                ownerDocumento: "BENEFICIARIO",
                                versaoCadastro: _vm.versaoCadastro
                              }
                            })
                          : _vm._e(),
                        _vm.isPEAS
                          ? _c(
                              "div",
                              [
                                _c("app-resumo-imovel-beneficiario", {
                                  attrs: {
                                    imovel: props.row.imovel,
                                    cadastroOriginal: props.row
                                  }
                                }),
                                props.row.imovel.documentos &&
                                props.row.imovel.documentos.length > 0
                                  ? _c("listagem-documentos", {
                                      attrs: {
                                        documentos: props.row.imovel.documentos,
                                        protocoloCadastroOriginal:
                                          _vm.cadastroOriginal.protocolo,
                                        ownerDocumento: "IMOVEL",
                                        versaoCadastro: _vm.versaoCadastro
                                      }
                                    })
                                  : _vm._e(),
                                _vm.beneficiarios.find(function(beneficiario) {
                                  return (
                                    props.row.pessoa.pessoaFisica.cpf ===
                                    beneficiario.pessoa.pessoaFisica.cpf
                                  )
                                })
                                  ? _c("app-resumo-geo", {
                                      attrs: {
                                        geo: props.row.georreferenciamento,
                                        "id-mapa": "mapaResumo" + props.row.id,
                                        idCadastro: "" + props.row.id,
                                        isCadastroOff:
                                          props.row.georreferenciamento
                                            .localizacoes.length > 0 &&
                                          !!props.row.georreferenciamento
                                            .localizacoes[0].geometry,
                                        exibeDocumentos: false,
                                        isVisualizarCadastro: true,
                                        isGeoBeneficiario: true,
                                        showMapa:
                                          props.row.georreferenciamento
                                            .localizacoes.length > 0
                                      }
                                    })
                                  : _vm._e(),
                                props.row.georreferenciamento.responsavel
                                  ? _c("informacoes-responsavel-geo", {
                                      attrs: {
                                        responsavel:
                                          props.row.georreferenciamento
                                            .responsavel
                                      }
                                    })
                                  : _vm._e(),
                                props.row.georreferenciamento.documentos &&
                                props.row.georreferenciamento.documentos
                                  .length > 0
                                  ? _c("listagem-documentos", {
                                      attrs: {
                                        documentos:
                                          props.row.georreferenciamento
                                            .documentos,
                                        protocoloCadastroOriginal:
                                          _vm.cadastroOriginal.protocolo,
                                        ownerDocumento: "GEO-BENEFICIARIO",
                                        versaoCadastro: _vm.versaoCadastro
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "CPF", prop: "pessoa.pessoaFisica.cpf" }
              }),
              _c("el-table-column", {
                attrs: { label: "Nome", prop: "pessoa.pessoaFisica.nome" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pessoa.pessoaFisica.nomeDaMae",
                  label: "Nome da Mãe"
                }
              }),
              _vm.canRemove
                ? _c("el-table-column", {
                    attrs: { label: "Ações" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.canRemove
                                ? _c("app-action-button", {
                                    attrs: {
                                      icone: "times",
                                      cor: "#CF0021",
                                      method: "removeBeneficiario",
                                      text: "Remover"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeBeneficiario(
                                          scope.row.pessoa.pessoaFisica.cpf
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1104921031
                    )
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next",
                  total: _vm.totalElements,
                  "page-size": _vm.CONFIGS.TAMANHO_PAGINACAO,
                  "current-page": _vm.pagina + 1
                },
                on: { "current-change": _vm.alterarPagina }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bce37bca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bce37bca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesBeneficiarios.vue
// module id = null
// module chunks = 